module.exports = __webpack_public_path__ + "img/service_icon4.ea6b0731.png";